import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SafeFromHarmRegionWorldData} from '../../../../shared/types/nso-data-portal/dashboard-data';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';
import {
  WorldInformationRestService
} from '../../../../shared/services/nso-data-portal/rest-services/world-information-rest.service';
import {SearchEntityLevels} from '../../../../shared/types/nso-data-portal/search-entity-levels';
import {
  RegionInformationRestService
} from '../../../../shared/services/nso-data-portal/rest-services/region-information-rest.service';

@Component({
  selector: 'wsd-safe-from-harm-world',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './safe-from-harm-world.html',
  styleUrls: ['./safe-from-harm-world.css']
})
export class SafeFromHarmWorld implements OnChanges {

  safeFromHarm$: Observable<SafeFromHarmRegionWorldData>;

  @Input()
  entityId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  @Input()
  groupAdminView: boolean;

  constructor(private worldService: WorldInformationRestService,
              private regionService: RegionInformationRestService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityLevel === SearchEntityLevels.REGION) {
      this.safeFromHarm$ = this.regionService.getSafeFromHarm(this.entityId).pipe(share());
    } else {
      this.safeFromHarm$ =
        this.worldService.getSafeFromHarm()
          .pipe(share());
    }
  }
}
